export default "__VITE_ASSET__BiQqluBm__"